export default __webpack_public_path__ + "static/media/logo.ffc51f8c.svg";